/**
 * nucleus-monitoring-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServiceInstance { 
    serviceName?: string;
    instanceId?: string;
    host?: string;
    hostname?: string;
    scheme?: string;
    port?: number;
    contextPath?: string;
    healthUrl?: string;
    version?: string;
    registeredAt?: string;
    lastHeartbeat?: string;
    status?: ServiceInstance.StatusEnum;
    tenant?: string;
}
export namespace ServiceInstance {
    export const StatusEnum = {
        Up: 'UP',
        Down: 'DOWN',
        Warn: 'WARN',
        Unknown: 'UNKNOWN'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


